import React from 'react';
//import {useHistory} from 'react-router-dom';
//import {LogoContainer} from './styled';

const ContentContainer = ({children = null}) => {
  // const history = useHistory();
  // const loggedOutRoutes = [
  //   '/login'
  // ];

  return (
    <>
      {children}
    </>
  );
};

export {ContentContainer};
